export const isExternal = (path) => {
    if (path) {
        return /^(https?:|mailto:|tel:)/.test(path);
    }
    else {
        return false;
    }
};
